// extracted by mini-css-extract-plugin
export default {"logo":"eLpNIlYOYKbVq0R8tIO_"};